module.exports = __webpack_public_path__ + "static/media/2.7d41a0cd.svg";